import { render, staticRenderFns } from "./IAside.vue?vue&type=template&id=5b10e5cb&scoped=true&"
import script from "./IAside.vue?vue&type=script&lang=js&"
export * from "./IAside.vue?vue&type=script&lang=js&"
import style0 from "./IAside.vue?vue&type=style&index=0&id=5b10e5cb&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"
import style1 from "./IAside.vue?vue&type=style&index=1&id=5b10e5cb&prod&lang=stylus&rel=stylesheet%2Fstylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b10e5cb",
  null
  
)

export default component.exports